<template>
  <w-sliding-popup ref="slidingPopup" :title="`슬라이드쇼 ${editType}`" width="700px">
    <div slot="content" class="slideshow-edit-content">
      <div class="mr-b20">
        <div class="title-h4 title-bar">슬라이드쇼 설정</div>
        <div class="list form-list">
          <el-form label-position="left" label-width="60px">
            <el-form-item label="슬라이드쇼 이름">
              <el-input v-model="slideshowInfo.slideshowName"></el-input>
            </el-form-item>
            <el-form-item label="슬라이드쇼 설명">
              <el-input resize="none" type="textarea" size="medium" :autosize="{ minRows: 5, maxRows: 5 }" v-model="slideshowInfo.slideshowDesc"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button class="mr-r4" size="large" type="solid" @click="save">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import DashboardConst from '@/constants/dashboard';
import WDashboardTree from '@/views/dashboard/components/frame/DashboardTree';
import DashboardAPI from '@/api/dashboard/common';
import { isEmpty } from '@/utils/basic';

export default {
  name: 'WSlideshowEditPopup',
  components: {
    WDashboardTree,
  },
  data() {
    return {
      DashboardConst,
      editType: '추가',
      slideshowInfo: {
        slideshowName: '',
        slideshowDesc: '',
      },
    };
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.SLIDESHOW_EDIT, this.open);
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.SLIDESHOW_EDIT, this.open);
  },
  methods: {
    open(options) {
      if (!isEmpty(options.slideshowInfo)) {
        this.slideshowInfo = options.slideshowInfo;
      }
      if (!isEmpty(options.editType)) {
        this.editType = options.editType;
      }
      this.$refs.slidingPopup.open();
    },
    close() {
      this.$refs.slidingPopup.close();
    },
    initData() {
      this.editType = '추가';
      this.slideshowInfo = {
        slideshowName: '',
        slideshowDesc: '',
      };
    },
    save() {
      const { slideshowName, slideshowDesc } = this.slideshowInfo;
      if (this.editType === '추가') {
        DashboardAPI.addSlideshow(slideshowName, slideshowDesc).then((response) => {
          if (response.data.success) {
            this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.SLIDESHOW_LOAD);
            this.$message({
              message: `슬라이드쇼를 ${this.editType}했습니다.`,
            });
            this.initData();
            this.close();
          } else {
            this.$message({
              message: `슬라이드쇼를 ${this.editType}하지 못했습니다.`,
            });
          }
        });
      } else {
        DashboardAPI.updateSlideshow([this.slideshowInfo]).then((response) => {
          if (response.data.success) {
            this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.SLIDESHOW_LOAD);
            this.$message({
              message: `슬라이드쇼를 ${this.editType}했습니다.`,
            });
            this.close();
          } else {
            this.$message({
              message: `슬라이드쇼를 ${this.editType}하지 못했습니다.`,
            });
          }
        });
      }
    },
  },
};
</script>
<style lang="scss">
.dashboard-slideshow-setting-content {
  height: calc(100% - 20px);
  padding: 20px;
  .slideshow-wrapper {
    height: 40%;
    .title-bar .btn-bar {
      display: flex;
      justify-content: space-between;
      // width: calc(100% - 90px);
    }
  }
  .slide-wrapper {
    height: 60%;

    .step-view {
      width: 100%;
      height: calc(100% - 163px);
    }

    .step-content {
      width: 100%;
      height: calc(100% - 59px);
    }

    .tree-box {
      display: inline-block;
      float: left;
      height: 100%;
      // width: calc(50% - 58px);
    }

    .add-btn-box {
      display: inline-block;
      height: 100%;
      width: 50px;
    }

    .drag-box {
      display: inline-block;
      float: right;
      height: 100%;
      width: 50%;
    }

    .close-icon {
      float: right;
      line-height: 28px;
      margin-right: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/popup/SlideshowEditPopup.vue